(function () {

  'use strict';

  function pxPrinterPropertiesMultiContextMenu(
    $timeout, $window
    ) {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        selectedTab: '=selectedTab',
        contextPosition: '=contextPosition',
        resource: '=resource',
        // auxiliaries: '=auxiliaries',
        callback: '&callback',
        updateParent: '&updateParent'
      },
      templateUrl: 'app/components/printerPropertiesMulti/_printerPropertiesMultiContextMenu/printerPropertiesMultiContextMenu.template.html',
      link: function (scope, element, attrs) {


        (function() {
          initContexContent();
        })();

        scope.$watch(function() {
          // initContexContent();
          return scope.contextPosition;
          }, function(oldVal, newVal){
          if (oldVal !== newVal) {
            initContexContent();
          }
        })

        function initContexContent() {
          checkValidPostion () 
        };

        function checkValidPostion () {

          var left = null;
          var top = null;

          $timeout(function() {
            var menuHeight = angular.element('.context-content-container').innerHeight();
            var menuWidth = angular.element('.context-content-container').innerWidth();


            var screenVertCenter = $window.innerHeight / 2;
            var menuVerticalCenter = menuHeight / 2;
            top = screenVertCenter - menuVerticalCenter;

            var screenHorCenter = window.innerWidth / 2
            var menuHorizontalCenter = menuWidth / 2;

            left = screenHorCenter - menuHorizontalCenter; 


            angular.element('.context-content-container').css({left: left , top: top});
            angular.element('.context-content-container').css({display: 'block'});
          }, 50)
        }

        scope.closePopup = function (context, bypass) {
          if (!bypass) { 
            if (context) {
              scope.callback({context: context});
            } else {
              scope.callback({context: false});
            }
          }
        }

        scope.relayUpdateParent = function () {
          scope.updateParent(); 
        }

        scope.$on('$destroy', function() {
          angular.element('.context-content-container').css({display: 'none'});
        });

      }
    }
  }



  pxPrinterPropertiesMultiContextMenu.$inject = ['$timeout', '$window'];

  angular
    .module('printix-admin')
    .directive('pxPrinterPropertiesMultiContextMenu', pxPrinterPropertiesMultiContextMenu);

})();